import styled from 'styled-components'

import { NATIVE_BASE_COLORS, FONT_SIZE } from '../../themes'
import { colorThemeSelector } from '../../helpers'

export const StyleEditRepeatModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 32px;

  .repeat-header-modal {
    color: ${NATIVE_BASE_COLORS.TEXT[900]};
    font-family: NunitoSansBold;
    font-size: ${FONT_SIZE.SM};
  }
`

export const StyleEditRepeatModalContent = styled.div`
  padding: 0px 32px;

  .description {
    font-family: NunitoSansSemiBold;
    font-size: ${FONT_SIZE.XS};
    color: ${NATIVE_BASE_COLORS.TEXT[700]};
  }
`

export const StyleEditRepeatModalFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 32px 32px 24px 32px;

  .submit-button {
    display: flex;
    width: 100%;
    height: 48px;
    padding: 10px 12px;
    justify-content: center;
    background-color: ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
    color: ${({ colorTheme }) => colorThemeSelector(colorTheme).FONT_COLOR.TEXT ?? COLOR.BLACK_1};
    outline: none;
    border: 0px;
    border-radius: 4px;
    font-family: NunitoSansRegular;
    font-size: ${FONT_SIZE.SM};
    cursor: pointer;
  }
`
